var _style, _linearGradient, _path, _linearGradient2, _path2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _linearGradient8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkerd = function SvgLinkerd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "linkerd_svg__linkerd-logo",
    x: 0,
    y: 0,
    viewBox: "0 0 138.9 129.2"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".linkerd_svg__st0{fill:url(#linkerd_svg__SVGID_1_)}.linkerd_svg__st1{fill:url(#linkerd_svg__SVGID_2_)}.linkerd_svg__st2{fill:#2beda7}.linkerd_svg__st3{fill:url(#linkerd_svg__SVGID_3_)}.linkerd_svg__st4{fill:url(#linkerd_svg__SVGID_4_)}.linkerd_svg__st5{fill:url(#linkerd_svg__SVGID_5_)}.linkerd_svg__st6{fill:url(#linkerd_svg__SVGID_6_)}.linkerd_svg__st7{fill:url(#linkerd_svg__SVGID_7_)}.linkerd_svg__st8{fill:url(#linkerd_svg__SVGID_8_)}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkerd_svg__SVGID_1_",
    x1: 130.52,
    x2: 130.52,
    y1: 24.532,
    y2: 79.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2BEDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018AFD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.9 24.5v49.7l9.2 5.3V29.8z",
    className: "linkerd_svg__st0"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkerd_svg__SVGID_2_",
    x1: 7.78,
    x2: 7.78,
    y1: 24.534,
    y2: 79.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2BEDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018AFD"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.2 79.5 9.2-5.3V24.5l-9.2 5.3z",
    className: "linkerd_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 79 42.1 24.3V92.8L50.8 70l-2.7 1.5zM92.6 117.4 48.1 91.7v10.6l11.9 6.9-14.3 8.3c-1 .6-1 1.9 0 2.5l7 4 16.5-9.5 16.5 9.5 7-4c.9-.6.9-2-.1-2.6",
    className: "linkerd_svg__st2"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkerd_svg__SVGID_3_",
    x1: 130.52,
    x2: 130.52,
    y1: 48.861,
    y2: 99.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2BEDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018AFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.9 54.1v44c0 1.1 1.2 1.8 2.2 1.3l6.3-3.6c.4-.3.7-.7.7-1.3V48.9z",
    className: "linkerd_svg__st3"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkerd_svg__SVGID_4_",
    x1: 110.368,
    x2: 110.368,
    y1: 60.496,
    y2: 111.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2BEDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018AFD"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m108 111.1 5.9-3.4c.7-.4 1.1-1.1 1.1-1.9V60.5l-9.2 5.3v44c0 1.1 1.2 1.8 2.2 1.3",
    className: "linkerd_svg__st4"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkerd_svg__SVGID_5_",
    x1: 90.216,
    x2: 90.216,
    y1: 72.13,
    y2: 123.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2BEDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018AFD"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m85.6 124 8.4-4.9c.4-.3.7-.7.7-1.3V72.1l-9.2 5.3V124z",
    className: "linkerd_svg__st5"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkerd_svg__SVGID_6_",
    x1: 48.089,
    x2: 48.089,
    y1: 72.13,
    y2: 123.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2BEDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018AFD"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m44.2 119.1 8.4 4.9V77.4l-9.2-5.3v45.7c.1.6.4 1 .8 1.3",
    className: "linkerd_svg__st6"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkerd_svg__SVGID_7_",
    x1: 27.937,
    x2: 27.937,
    y1: 60.495,
    y2: 111.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2BEDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018AFD"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m24.4 107.7 5.9 3.4c1 .6 2.2-.1 2.2-1.3v-44l-9.2-5.3v45.3c.1.8.5 1.5 1.1 1.9",
    className: "linkerd_svg__st7"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkerd_svg__SVGID_8_",
    x1: 7.785,
    x2: 7.785,
    y1: 48.861,
    y2: 99.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2BEDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018AFD"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m4.3 96 5.9 3.4c1 .6 2.2-.1 2.2-1.3v-44l-9.2-5.3v45.3c0 .8.4 1.5 1.1 1.9",
    className: "linkerd_svg__st8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m135.1 29.8-9.2-5.3-16.5 9.5-11-6.3 14.3-8.3c1-.6 1-1.9 0-2.5l-5.9-3.4c-.7-.4-1.5-.4-2.2 0l-15.4 8.9-11-6.3 14.3-8.3c1-.6 1-1.9 0-2.5l-5.9-3.4c-.7-.4-1.5-.4-2.2 0L69 10.8 53.7 1.9c-.7-.4-1.5-.4-2.2 0l-5.9 3.4c-1 .6-1 1.9 0 2.5l80.3 46.3 9.2-5.3-16.5-9.5zM31.4 13.5l-5.9 3.4c-1 .6-1 1.9 0 2.5l80.3 46.3 9.2-5.3-81.4-47c-.7-.3-1.5-.3-2.2.1M3.2 29.8l16.5 9.5-16.5 9.6 9.2 5.3 16.5-9.6L39.8 51l-16.4 9.5 9.1 5.3L49 56.3l11 6.3-16.5 9.5 9.2 5.3 16.4-9.5 16.5 9.5 9.2-5.3-82.4-47.6z",
    className: "linkerd_svg__st2"
  })));
};
export { SvgLinkerd as ReactComponent };
export default "data:image/svg+xml;base64,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";